import {Fragment} from "react";
import TextInput from "../../../../form/TextInput";
import DateTimeInput from "../../../../form/DateTimeInput";
import Select from "../../../../form/Select";
import AddressControl from "../../../../form/AddressControl";
import TextArea from "../../../../form/TextArea";
import React from "react";
import ComponentConfig from "../../../../form/ComponentConfig";
import Button from "../../../../form/Button";
import classNames from 'classnames';
import DetailsButton from "../../../../form/DetailsButton";

export default (props) => <Fragment>
    <div className="row form-row">
        <div className={classNames({"col-sm-2": props.values.component, "col-md-4": !props.values.component})}>
            <TextInput
                name={props.componentConfig.idfield}
                value={props.values[props.componentConfig.idfield]}
                label="Kód"
                role="idfield"
            />
        </div>
        <div className="col-sm-4">
            <DateTimeInput
                name="accountdate"
                disabled={props.edit ? false : props.disabled || !props.correctable}
                value={props.values.accountdate}
                label="Elszámolás dátuma"
                showTime={false}
                saveChanges={props.setFieldValue}
            />
        </div>
        <div className="col-sm-3">
            <TextInput
                name="billnum"
                disabled={!props.external}
                value={props.values.billnum}
                label="Sorszám"
                saveChanges={props.setFieldValue}
            />
        </div>
        {props.values.component && <div className="col-sm-3">
            <DetailsButton
                component_type={props.values.component}
                component_id={props.values.component_id}
            />
        </div>}
    </div>
    <div className="row form-row">
        <div className="col-sm-3">
            <Select
                label="Partner"
                name="to"
                component="partner"
                objectValue={true}
                labelKey="name"
                valueKey="partner_id"
                storeType="remote"
                disabled={true}
                value={props.values.to}
                saveChanges={props.setFieldValue}
            />
        </div>
        <div className="col-md-9">
            <div className="row">
                <AddressControl
                    disabled={true}
                    name="to.address"
                    value={(props.values.to || {}).address}
                    label="Cím"
                    saveChanges={props.setFieldValue}
                />
            </div>
        </div>
    </div>
    <div className="row form-row">
        <div className="col-sm-4">
            <DateTimeInput
                name="issuedate"
                disabled={props.disabled || !props.correctable}
                value={props.values.issuedate}
                label="Kiállítás dátuma"
                showTime={false}
                saveChanges={props.setFieldValue}
            />
        </div>
        <div className="col-sm-4">
            <DateTimeInput
                name="transactiondate"
                disabled={props.edit ? false : props.disabled || !props.correctable}
                value={props.values.transactiondate}
                label="Teljesítés dátuma"
                showTime={false}
                saveChanges={props.setFieldValue}
            />
        </div>
        <div className="col-sm-4">
            <DateTimeInput
                name="deadline"
                disabled={props.edit ? false : props.disabled || !props.correctable}
                value={props.values.deadline}
                label="Fizetési határidő"
                showTime={false}
                saveChanges={props.setFieldValue}
            />
        </div>
    </div>
    <div className="row form-row">
        <div className="col-md-12">
            <TextArea
                name="comment"
                disabled={props.edit ? false : props.disabled || !props.correctable}
                value={props.values.comment}
                label="Megjegyzés"
                saveChanges={props.setFieldValue}
            />
        </div>
    </div>
</Fragment>